<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_new_feature") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #446e80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload -->
          <base-image-upload-input
            col="12"
            identifier="feature_image"
            :placeholder="$t('PLACEHOLDERS.feature_image')"
            @selectImage="selectImage"
          />
          <!-- End:: Image Upload -->
          <!-- Start:: Name AR Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <!-- End:: Name AR Input -->

          <!-- Start:: Name EN Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <!-- End:: Name EN Input -->

          <!-- Start:: Description AR Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.description_ar"
            required
          />
          <!-- End:: Description AR Input -->

          <!-- Start:: Description EN Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.description_en"
            required
          />
          <!-- End:: Description EN Input -->

          <!-- Start:: Activation Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Activation Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreateFeature",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name_ar: null,
        name_en: null,
        description_ar: null,
        description_en: null,
        is_active: true,
      },
      // End:: Data Collection To Send
    };
  },

  methods: {
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // End:: Select Upload Image,

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.name_ar) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_ar"));
        return;
      }
      if (!this.data.name_en) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_en"));
        return;
      }
      if (!this.data.description_ar) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.description_ar"));
        return;
      }
      if (!this.data.description_en) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.description_en"));
        return;
      }
      if (this.data.name_ar.length < 3 || this.data.name_ar.length > 50) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_ar_length"));
        return;
      }
      if (this.data.name_en.length < 3 || this.data.name_en.length > 50) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_en_length"));
        return;
      }
      if (
        this.data.description_ar.length < 3 ||
        this.data.description_ar.length > 500
      ) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.description_ar_length"));
        return;
      }
      if (
        this.data.description_en.length < 3 ||
        this.data.description_en.length > 500
      ) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.description_en_length"));
        return;
      }

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Start:: Append Request Data
      REQUEST_DATA.append("name[ar]", this.data.name_ar);
      REQUEST_DATA.append("name[en]", this.data.name_en);
      REQUEST_DATA.append("description[ar]", this.data.description_ar);
      REQUEST_DATA.append("description[en]", this.data.description_en);
      REQUEST_DATA.append("is_active", this.data.is_active ? 1 : 0);

      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `features`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/features/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },
};
</script>
